import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdatesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">
                最近更新
              </h2>
              <span className="px-3 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                实时
              </span>
            </div>
            <p className="text-sm text-foreground-500">紧跟最新章节，不错过任何精彩</p>
          </div>
          <Link
            to="/category/all"
            className="hidden md:inline-flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {latestUpdates.slice(0, 8).map((update, idx) => (
            <Link
              key={idx}
              to={`/comic/${update.slug}`}
              className="group flex items-center gap-4 p-4 bg-background-50 rounded-lg hover:bg-background-200/50 transition-colors duration-200"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-book-open-line text-lg"></i>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 truncate">
                  {update.comicTitle}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">{update.chapter}</p>
              </div>
              <span className="flex-shrink-0 text-[11px] text-foreground-400 whitespace-nowrap">{update.time}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}